import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/src/userSegRedirectEntrypoint.entrypoint.tsx';
import { jiraBusinessSessionsRoute } from '@jira/router-routes__business-sessions-routes/src/jiraBusinessSessionsRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { businessSessionsEntrypoint } from '@jira/spa-apps__agents-sessions/src/businessSessionsEntrypoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const businessSessionsPageEntryPoint = createPageEntryPoint({
	main: businessSessionsEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
	redirect: userSegRedirectEntrypoint,
});

export const jiraBusinessSessionsRouteEntry: Route = createEntry(jiraBusinessSessionsRoute, () => ({
	group: 'classic-business',
	ufoName: 'jwm.sessions-view',
	layout: businessProjectLayout,
	skeleton: ThemedLazySkeleton,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: getProjectViewResources(),
	entryPoint: () =>
		expVal('jira_space_sessions', 'isEnabled', false)
			? businessSessionsPageEntryPoint
			: notFoundPageEntrypoint,
	supportsProjectTheme: 'full',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
